module.exports = __webpack_public_path__ + "static/mid_01-21a21078ac3cec29734b8537dd19e03a.png";